import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from './auth.service';
import {Observable, of} from 'rxjs';
import {map, catchError} from 'rxjs/operators';

@Injectable({ providedIn:'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}
  
  canActivate(): Observable<boolean> | boolean {
    // 🔍 Si el token está próximo a expirar, refrescarlo automáticamente
    if (this.auth.isLogged() && this.auth.isTokenExpiringSoon()) {
      return this.auth.refreshToken().pipe(
        map(() => {
          return true;
        }),
        catchError(() => {
          console.error('❌ Error renovando token en guard, redirigiendo al login');
          this.router.navigate(['/login']);
          return of(false);
        })
      );
    }

    // ✅ Token válido o verificación estándar
    if (this.auth.isLogged()) {
      return true;
    }
    
    // ❌ No hay token válido
    this.router.navigate(['/login']);
    return false;
  }
}
